import {
  COUNTRIES,
  COUNTRY_MY,
  COUNTRY_ID,
  COUNTRY_VN,
  APP_SHOWROOM,
  APP_LOAN_TRACKER,
  APP_CREDIT_CONTROL,
  APP_ANALYTICS,
  APP_COMMISSION_TRACKER,
} from './constants';

// used to restrict access to certain paths when a feature is disabled in a country
export const featuresPathRegex = {
  blast: [/^\/campaigns\/[^/]+\/email(\/.*)?$/, /^\/campaigns\/[^/]+\/sms(\/.*)?$/],
  leads: [/^\/leads(\/.*)?$/],
  campaigns: [
    /^\/(campaigns|audiences)(\/.*)?$/,
    /^\/settings\/(api_integrations|call|facebook|email_verifications)(\/.*)?$/,
  ],
  // matches all /settings/* routes except /settings/auto_assignment*
  settings: [/^\/settings(?!\/auto_assignment)(\/.*)?$/],
};

export const countryFeatures = {
  [COUNTRY_MY]: {
    ...COUNTRIES[COUNTRY_MY],
    enabledApps: [
      APP_SHOWROOM,
      APP_LOAN_TRACKER,
      APP_CREDIT_CONTROL,
      APP_ANALYTICS,
      APP_COMMISSION_TRACKER,
    ],
    features: {
      creditCheck: true,
      salescandy: true,
      srb: true,
      promotionBlast: true,
      navLeads: true,
      navCampaigns: true,
      helpButton: true,
      autoAssignmentCampaignSourceFilter: true,
      bookingConcept: false,
      identityDocument: false,
      navSettings: true,
      settingsDefaultPath: '/settings/fields',
      buyerAccess: true,
      callLogs: true,
      customerMenu: true,
      moreFilter: true,
      initialPath: '/',
      staticUserActivityLog: false,
      activityLog: false,
    },
  },
  [COUNTRY_ID]: {
    ...COUNTRIES[COUNTRY_ID],
    enabledApps: [
      APP_SHOWROOM,
      APP_ANALYTICS,
      APP_CREDIT_CONTROL,
    ],
    features: {
      creditCheck: false,
      salescandy: true,
      srb: true,
      promotionBlast: false,
      navLeads: true,
      navCampaigns: true,
      helpButton: true,
      autoAssignmentCampaignSourceFilter: true,
      bookingConcept: false,
      identityDocument: false,
      navSettings: true,
      settingsDefaultPath: '/settings/fields',
      buyerAccess: true,
      callLogs: true,
      customerMenu: true,
      moreFilter: true,
      initialPath: '/',
      staticUserActivityLog: false,
      activityLog: false,
    },
  },
  [COUNTRY_VN]: {
    ...COUNTRIES[COUNTRY_VN],
    enabledApps: [
      APP_SHOWROOM,
      APP_ANALYTICS,
      APP_CREDIT_CONTROL,
    ],
    features: {
      creditCheck: false,
      salescandy: false,
      srb: false,
      promotionBlast: false,
      TokenPayment: true,
      navLeads: false,
      navCampaigns: false,
      helpButton: false,
      autoAssignmentCampaignSourceFilter: false,
      bookingConcept: true,
      identityDocument: true,
      navSettings: false,
      settingsDefaultPath: '/settings/auto_assignment',
      buyerAccess: false,
      callLogs: false,
      customerMenu: false,
      moreFilter: false,
      initialPath: '/opportunities?page=1',
      staticUserActivityLog: true,
      activityLog: true,
      // CPI-1197: Grant Level 2 roles (Supervisor, Sales Manager, Sales Admin) L1-level access
      level2ViewAll: true,
      // CPI-1213: Allow HQ / Sales Admin / Agency Leader / Agency Admin to re-assign the
      // agent on a booking from the booking detail page.
      reassignAgent: true,
      // CPI-1234: Allow the agent to raise a booking cancellation from the CRM booking
      // detail page, picking one of the two cancellation scenarios.
      cancelBooking: true,
      // CPI-1225: show the deposit payments recorded in Showroom on the CRM booking detail,
      // read-only. Vietnam is the only country with a deposit as a second, separate sum from
      // the booking fee, so Malaysia and Indonesia get no panel and fire no query.
      viewDeposit: true,
    },
  },
};
